import styled from 'styled-components'
import { Row } from 'react-flexbox-grid'
import { Checkbox } from 'components/forms'

export const HighlightedRow = styled(Row)`
	margin-bottom: 0.5rem;
	padding: 20px;
	background-color: #f4f3f384;
	border-radius: 5px;
	height: 170px;
`
export const SCheckbox = styled(Checkbox)`
	label {
		align-items: center;
	}
`
